import { render, staticRenderFns } from "./MedicamentoModalEdit.vue?vue&type=template&id=abb3f8ae"
import script from "./MedicamentoModalEdit.vue?vue&type=script&lang=js"
export * from "./MedicamentoModalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports